import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useApi } from "../store/hooks";
import Loader from "./common/Loader";
import { sleep } from "../utils/utils";
import { GoToTheNextStep } from "./Step";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Layout from "./common/Layout";

const SepaMandateCallback = () => {
  const standalone = window.self === window.top;
  const { t } = useTranslation();
  const { getSepaMandate, getWorkflow } = useApi();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isSignatureFailed, setIsSignatureFailed] = useState(false);
  const DONE_STATUS = "Done";
  const RETRY_STATUSES = new Set([
    "Deleted",
    "Expired",
    "Canceled",
    "Approval",
    "Rejected",
    "Declined",
    "Unknown",
  ]);
  const TERMINAL_STATUSES = new Set([DONE_STATUS, ...RETRY_STATUSES]);

  useEffect(() => {
    const fetchSepaMandateWithRetry = async () => {
      let signatureStatus;
      let retryCount = 0;
      try {
        while (retryCount < 30 && !TERMINAL_STATUSES.has(signatureStatus)) {
          await sleep(5000);
          const resp = await getSepaMandate();
          signatureStatus = resp?.status;
          retryCount += 1;
        }
      } catch (error) {
        setIsSignatureFailed(true);
        return;
      }

      if (!standalone) {
        const action = signatureStatus === DONE_STATUS ? "SUCCESS" : "RETRY";
        window.parent.postMessage(
          { type: "SEPA_MANDATE_DONE", action },
          window.location.origin,
        );
      } else if (signatureStatus === DONE_STATUS) {
        await GoToTheNextStep(navigate, dispatch, getWorkflow);
      }
    };
    fetchSepaMandateWithRetry();
  }, []);

  const retryMandatSepa = () => {
    if (standalone) {
      GoToTheNextStep(navigate, dispatch, getWorkflow);
    } else {
      window.parent.postMessage(
        { type: "SEPA_MANDATE_DONE", action: "RETRY" },
        window.location.origin,
      );
    }
    setIsSignatureFailed(false);
  };

  const renderContent = () => (
    <div className={`${!standalone ? "full-screen az-container" : ""}`}>
      {isSignatureFailed ? (
        <div className="id-check-failure-container">
          <div className="result-header">
            <div className="mb-3">
              <img
                src={process.env.PUBLIC_URL + "/images/error-cross.svg"}
                alt="Error Cross Icon"
                className="result-icon"
              />
            </div>
          </div>
          <span className="text-danger mb-4">
            {t("sepaMandateCallback.failed.message")}
            <br />
            {t("sepaMandateCallback.failed.subMessage")}
          </span>
          <span>
            <img
              src={process.env.PUBLIC_URL + "/images/reload.svg"}
              alt="Error Cross Icon"
            />
            <button className="btn btn-link" onClick={retryMandatSepa}>
              {t("global.retry")}
            </button>
          </span>
        </div>
      ) : (
        <Loader
          loading={true}
          title={t("initial.loader.title")}
          message={t("sepaMandateCallback.loading.message")}
        />
      )}
    </div>
  );
  return standalone ? (
    <Layout>
      <div className="az-title">{t("sepaMandate.sign.title")}</div>
      {renderContent()}
    </Layout>
  ) : (
    renderContent()
  );
};

export default SepaMandateCallback;
